import { useQuery } from '@apollo/client';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { actionBasedClinicsForLabTemplate } from 'apollo/templates/organization';
import { Organization } from 'models/organization';
import React, { FC, Fragment } from 'react';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { useTranslation } from 'react-i18next';

type ActionBasedCustomersDropdownProps = {
    onClinicFilterChange: (_: React.SyntheticEvent, clinic: Organization | null) => void;
    selectedClinic?: Organization | null;
};

const ActionBasedCustomersDropdown: FC<ActionBasedCustomersDropdownProps> = ({
    onClinicFilterChange,
    selectedClinic,
}: ActionBasedCustomersDropdownProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const { showBoundary } = useDenthubErrorBoundary();
    const { data: { actionBasedClinicsForLab } = {}, loading } = useQuery(actionBasedClinicsForLabTemplate, {
        variables: {},
        onError(error) {
            showBoundary(error);
        },
    });
    return (
        <Fragment>
            {!loading && (
                <FormControl fullWidth>
                    <Autocomplete
                        id="clinic-select"
                        options={actionBasedClinicsForLab || []}
                        getOptionLabel={(clinic: Organization) => `${clinic.name || ''}`}
                        renderOption={(props, option: Organization) => (
                            <li {...{ ...props, key: option?._id }}>
                                {option.name} &nbsp;
                                {!option.parentClinicId && !option.local && option.isMain ? (
                                    <i> ({translate('common:MAIN')})</i>
                                ) : undefined}
                            </li>
                        )}
                        isOptionEqualToValue={(option: Organization, value: Organization) => option?._id === value?._id}
                        value={(selectedClinic || { name: '' }) as Organization}
                        onChange={onClinicFilterChange}
                        renderInput={(params) => <TextField {...params} label={translate('common:CUSTOMER')} />}
                    />
                </FormControl>
            )}
        </Fragment>
    );
};

export default ActionBasedCustomersDropdown;
